// Lienzo del editor de marca de agua. El HOST le da el contenedor dimensionado
// (mismo slot donde Recortar pone su canvas); acá solo va el CanvasStage con la
// escena del hook. Sin fondo propio: se apoya en el bg de la superficie. En
// mobile, el "Desactivar" lo inyecta cada superficie en el header del shell
// (setMobileRightAction), a la misma altura que el volver.

import { Loader2 } from 'lucide-react';
import { CanvasStage } from '../../pages/edicionGrafica/canvas/CanvasStage';
import type { WatermarkEditorState } from './useWatermarkEditor';

export function WatermarkEditorCanvas({ state }: { state: WatermarkEditorState }) {
  if (!state.ready) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-brand-primary" />
      </div>
    );
  }
  return (
    <div className="w-full h-full flex">
      <CanvasStage
        scene={state.api.scene}
        select={state.api.select}
        checkpoint={state.api.checkpoint}
        updateLayer={state.api.updateLayer}
        hideFloatingNav
      />
    </div>
  );
}
